var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wizard-step-content step3-finish" }, [
    !_vm.duplicationStarted || _vm.duplicationStatus !== ""
      ? _c("div", { staticClass: "step3-summary" }, [
          _c("h3", { staticClass: "step3-title" }, [
            _vm._v(_vm._s(_vm.stepTitle))
          ]),
          _vm._v(" "),
          false
            ? _c("div", { staticClass: "summary-card" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "summary-card__body" }, [
                  _c(
                    "div",
                    { staticClass: "summary-options-grid" },
                    _vm._l(_vm.displayOptions, function(opt) {
                      return _c(
                        "div",
                        {
                          key: opt.key,
                          staticClass: "summary-option",
                          class: {
                            "summary-option--enabled": opt.enabled,
                            "summary-option--disabled": !opt.enabled
                          }
                        },
                        [
                          _c("i", {
                            class: opt.enabled
                              ? "fas fa-check-circle text-success"
                              : "fas fa-times-circle text-muted"
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(opt.label))])
                        ]
                      )
                    }),
                    0
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "summary-card" }, [
            _c("div", { staticClass: "summary-card__body" }, [
              _c(
                "div",
                {
                  staticClass:
                    "summary-item summary-item--highlight summary-title"
                },
                [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.wizard.projectOptions.title))
                  ]),
                  _vm._v(" "),
                  !["completed", "failed"].includes(_vm.duplicationStatus)
                    ? _c("div", { staticClass: "step3-action" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-duplicate",
                            attrs: { disabled: _vm.duplicationStarted },
                            on: { click: _vm.startDuplication }
                          },
                          [
                            !_vm.duplicationStarted
                              ? _c("img", {
                                  attrs: {
                                    src: require("@/csmworkflow/img/duplication.svg")
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.duplicationStarted &&
                            _vm.duplicationStatus !== "failed"
                              ? _c("b-spinner", {
                                  staticClass: "mr-2",
                                  attrs: { small: "" }
                                })
                              : _vm._e(),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.duplicationStarted
                                    ? "Duplicating..."
                                    : "Start Duplication"
                                ) +
                                "\n            "
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              !_vm.duplicationStarted
                ? _c(
                    "div",
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _vm.selectedDeliverables.length === 0
                        ? _c("div", { staticClass: "text-muted p-2" }, [
                            _vm._v(
                              "\n            No deliverables selected.\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.selectedDeliverables, function(deliv) {
                        return _c(
                          "div",
                          { key: deliv.id, staticClass: "summary-deliverable" },
                          [
                            _c(
                              "span",
                              { staticClass: "summary-deliverable__title" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(deliv.title) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "summary-deliverable-right" },
                              [
                                !_vm.isOSMP(deliv)
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "summary-deliverable__type"
                                      },
                                      [_vm._v("Project Deliverable")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isOSMP(deliv)
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "summary-deliverable__posts"
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.getSelectedPostCount(deliv)
                                            ) +
                                            " / " +
                                            _vm._s(
                                              _vm.getTotalPostCount(deliv)
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.getPostCountLabel(deliv)
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              false
                ? _c("div", { staticClass: "step3-totals" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.selectedDeliverables.length) +
                          " deliverable" +
                          _vm._s(
                            _vm.selectedDeliverables.length !== 1 ? "s" : ""
                          )
                      )
                    ]),
                    _vm._v(" "),
                    _vm.totalSelectedPosts > 0
                      ? _c("span", { staticClass: "ml-3" }, [
                          _vm._v(
                            "\n            · " +
                              _vm._s(_vm.totalSelectedPosts) +
                              " social media post" +
                              _vm._s(_vm.totalSelectedPosts !== 1 ? "s" : "") +
                              "\n          "
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.duplicationStarted
                ? _c("div", { staticClass: "step3-progress" }, [
                    _vm.queueMessage && _vm.duplicationStatus === "pending"
                      ? _c(
                          "div",
                          { staticClass: "step3-queue-msg text-center" },
                          [
                            _c("p", { staticClass: "mt-3" }, [
                              _vm._v(_vm._s(_vm.queueMessage))
                            ]),
                            _vm._v(" "),
                            _vm._m(2)
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.duplicationStatus === "processing" ||
                    _vm.duplicationStatus === "pending"
                      ? _c(
                          "div",
                          { staticClass: "step3-progress-bar" },
                          [
                            _c("b-progress", {
                              staticClass: "mb-2",
                              attrs: {
                                value: _vm.progressPercent,
                                height: "20px",
                                variant: "success"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "step3-progress-info" }, [
                              _vm.progressCount
                                ? _c(
                                    "span",
                                    { staticClass: "step3-progress-count" },
                                    [_vm._v(_vm._s(_vm.progressCount))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "step3-progress-message" },
                                [_vm._v(_vm._s(_vm.progressMessage))]
                              ),
                              _vm._v(" "),
                              _vm.progressLabel
                                ? _c(
                                    "span",
                                    { staticClass: "step3-progress-label" },
                                    [_vm._v(_vm._s(_vm.progressLabel))]
                                  )
                                : _vm._e()
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.duplicationStatus === "completed"
                      ? _c(
                          "div",
                          { staticClass: "step3-complete text-center" },
                          [
                            _c("i", {
                              staticClass: "fas fa-check-circle text-success",
                              staticStyle: { "font-size": "3rem" }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "mt-3 step3-complete-message" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.progressMessage ||
                                      "Project duplicated successfully!"
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.newProjectNumber
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-duplicate btn-primary mt-2",
                                    on: { click: _vm.goToNewProject }
                                  },
                                  [
                                    _vm._v(
                                      "\n               View New Project\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.duplicationStatus === "failed"
                      ? _c("div", { staticClass: "step3-failed text-center" }, [
                          _c("i", {
                            staticClass: "fas fa-times-circle text-danger",
                            staticStyle: { "font-size": "3rem" }
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "mt-3",
                              staticStyle: { "font-weight": "bold" }
                            },
                            [
                              _vm._v(
                                "A system error occurred. Duplication failed."
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-muted" }, [
                            _vm._v(
                              "An error notification has been sent to Pattern Interactive."
                            )
                          ]),
                          _vm._v(" "),
                          _vm.sourceProjectNumber
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-cancel mt-2",
                                  on: { click: _vm.goToSourceProject }
                                },
                                [
                                  _vm._v(
                                    "\n              Back to Project\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "summary-card__header" }, [
      _c("i", { staticClass: "fas fa-cog" }),
      _vm._v(" Project Options\n      ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "summary-item summary-item--highlight-sm" },
      [_c("strong", [_vm._v("Selected Deliverables")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-muted" }, [
      _c("small", [
        _vm._v(
          "Another project is being duplicated. Your request will begin shortly."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }